import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9334Query } from './hooks/usePW9334Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9334Api';
import './PW9334Form.css';

/**
 * Compute default YYYYMM strings: from = 1 year ago, to = current month.
 */
function getDefaultYearMonth(): { from: string; to: string } {
  const now = new Date();
  const toYM = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
  const past = new Date(now);
  past.setFullYear(past.getFullYear() - 1);
  const fromYM = `${past.getFullYear()}${String(past.getMonth() + 1).padStart(2, '0')}`;
  return { from: fromYM, to: toYM };
}

const PW9334Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePW9334Query();

  const defaults = getDefaultYearMonth();
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [empFrom, setEmpFrom] = useState('');
  const [empTo, setEmpTo] = useState('');
  const [yearMonFrom, setYearMonFrom] = useState(defaults.from);
  const [yearMonTo, setYearMonTo] = useState(defaults.to);

  const handleQuery = () => {
    const req: QueryRequest = {
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'ZZZZ',
      empFrom: empFrom.trim(),
      empTo: empTo.trim() || 'ZZZZZZZZ',
      yearMonFrom: yearMonFrom.trim(),
      yearMonTo: yearMonTo.trim(),
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9334-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          薪資異動記錄明細 (pw9334f1)
        </h2>

        <QueryParams
          deptFrom={deptFrom}
          deptTo={deptTo}
          empFrom={empFrom}
          empTo={empTo}
          yearMonFrom={yearMonFrom}
          yearMonTo={yearMonTo}
          loading={loading}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onEmpFromChange={setEmpFrom}
          onEmpToChange={setEmpTo}
          onYearMonFromChange={setYearMonFrom}
          onYearMonToChange={setYearMonTo}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的薪資異動資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9334Form;
